import * as React from 'react';
import { ProtectedPage } from '../genericComponents/Page/ProtectedPage/ProtectedPage';
import { UserRole } from '../../types/UserRole';
import { CenterContainer } from '../LoginPage/internalComponents/CenterContainer';
import { EmailValidation } from './internalComponents/EmailValidation';

export class EmailValidationPage extends React.Component {
    /** le props: l'etat externe */
    props: {
        match: { path: string, url: string, isExact: boolean, params: { token: string } };
    };
    /** le state: l'etat interne */
    state: {};

    /**
     * construit la page de validation
     * @param {{}} props
     */
    constructor(props: {}) {
        super(props);
        this.state = {};
    }

    /**
     * le rendu de la classe EmailValidationPage
     * @returns {JSX.element}
     */
    render() {

        return (
            <ProtectedPage
                allowedUsers={[
                    UserRole.USER,
                    UserRole.SUPER_ADMIN,
                    UserRole.SEMI_PRO,
                    UserRole.NOT_LOGED_IN,
                    UserRole.MEMBER,
                    UserRole.ADMIN,
                ]}
            >
                <div className="LoginPageChorinitia">
                    <CenterContainer>
                        <EmailValidation token={this.props.match.params.token} />
                    </CenterContainer>
                </div>
            </ProtectedPage>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/EmailValidationPage/EmailValidationPage.tsx